// Vendors
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

// Components
import FormattedMessage from '@molecules/FormattedMessage';

// Assets
import warningIcon from '@assets/icons/errorIcon.svg';
import { useAppDispatch, useAppSelector } from '@/store/store';
import { postRetryPaymentStart } from '@store/features/invoice/invoiceSlice';

const PaymentFailure: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { transactionDetails } = useAppSelector((state) => state.transaction);

  const handleRetryPay = () => {
    if (transactionDetails) {
      dispatch(postRetryPaymentStart({ transactionId: transactionDetails.transactionId }));
      void navigate('/pay');
    }
  };

  return (
    <div className="payment-failure_wrap">
      <div>
        <div className="title_wrap">
          <div>
            <img src={warningIcon} alt="warning" className="warning-icon" />
            <Typography className="title">
              <FormattedMessage id="FAILURE_SCREEN.MESSAGE" />
            </Typography>
          </div>
        </div>

        {transactionDetails && (
          <div className="invoice-container">
            <div className="invoice-details">
              <div className="detail-row">
                <Typography className="label">
                  <FormattedMessage id="SUCCESS_SCREEN.LABEL.CUST_ID" />
                </Typography>
                <Typography className="value">{transactionDetails.customerNumber}</Typography>
              </div>
              <div className="detail-row">
                <Typography className="label">
                  <FormattedMessage id="SUCCESS_SCREEN.LABEL.OWNER" />
                </Typography>
                <Typography className="value">
                  <span>{transactionDetails.customer?.firstName}</span>{' '}
                  <span>{transactionDetails.customer?.lastName}</span>
                  <br />
                  <span>{transactionDetails.customer?.address?.address1}</span>{' '}
                  <span>{transactionDetails.customer?.address?.address2}</span>
                  <br />
                  <span>
                    {transactionDetails.customer?.address?.city},{' '}
                    {transactionDetails.customer?.address?.state}{' '}
                    {transactionDetails.customer?.address?.zipcode}
                  </span>
                </Typography>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="button-group">
        <button className="btn" onClick={handleRetryPay}>
          <Typography className="btn-label retry">
            <FormattedMessage id="FAILURE_SCREEN.BUTTON.RETRY" />
          </Typography>
        </button>
        <button className="btn primary" onClick={() => void navigate('/invoices')}>
          <Typography className="btn-primary-label">
            {' '}
            <FormattedMessage id="FAILURE_SCREEN.BUTTON.BACK_TO_INVOICES" />
          </Typography>
        </button>
      </div>
    </div>
  );
};

export default PaymentFailure;
